import { Icon, NoData } from "../../../../../components";
import { RLCSYaraEntry } from "../../../@types/rldynamicanalysis/yara";
import { SOURCE_TYPE_MAPPING } from "./utils";

export const RLCloudSandboxYaraRuleSchema = {
  fields: [
    {
      name: "details",
      displayTitle: "",
      sortable: false,
      className: "row-expandable__expand-cell",
      component: () => (
        <Icon
          name="chevron-down"
          className="row-expandable__expand-cell-icon"
        />
      ),
      style: {
        width: "5%",
        textAlign: "center",
        verticalAlign: "middle"
      }
    },
    {
      name: "description",
      displayTitle: "Matched Rule Description",
      sortable: true,
      component: (d: RLCSYaraEntry) => d.description || <NoData />,
      style: { width: "50%" }
    },
    {
      name: "source_types",
      displayTitle: "YARA Match Sources",
      sortable: true,
      component: (d: RLCSYaraEntry) =>
        d.source_types.length > 0 ? (
          <span>
            {d.source_types
              .map(sourceType => SOURCE_TYPE_MAPPING[sourceType])
              .join(", ")}
          </span>
        ) : (
          <NoData />
        ),
      style: { width: "45%" }
    }
  ]
};
